module.exports = __webpack_public_path__ + "fonts/Nunito-Regular.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/common/fonts/Nunito/Nunito-Regular.ttf
// module id = 3448
// module chunks = 0